import { orderTestServiceCloud } from "@/services/orderTestRequest";

export function getJwtTokenCustomerListApi() {
  return orderTestServiceCloud({
    url: "/customer/getJwtTokenCustomerList",
    method: "get"
  });
}

export function getUserInfoApi(data) {
  return orderTestServiceCloud({
    url: "/customer/getCustomerInfo",
    method: "post",
    data
  });
}
